"use strict";
/**
 * Domain Core Primitives for man-core (TypeScript).
 * Provides foundational DDD building blocks:
 * BaseDomainException, BaseValueObject, BaseEntity, BaseDomainEvent, BaseAggregateRoot
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAggregateRoot = exports.BaseDomainEvent = exports.BaseEntity = exports.BaseValueObject = exports.BaseDomainException = void 0;
class BaseDomainException extends Error {
    constructor(message) {
        super(message);
        this.name = 'BaseDomainException';
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.BaseDomainException = BaseDomainException;
class BaseValueObject {
    /**
     * Value equality check for immutable value objects.
     */
    equals(other) {
        if (!other)
            return false;
        if (other.constructor !== this.constructor)
            return false;
        return JSON.stringify(this) === JSON.stringify(other);
    }
}
exports.BaseValueObject = BaseValueObject;
class BaseEntity {
    _id;
    _createdAt;
    _updatedAt;
    constructor(id, createdAt, updatedAt) {
        if (id === null || id === undefined) {
            throw new BaseDomainException('Entity ID cannot be null or undefined');
        }
        this._id = id;
        this._createdAt = createdAt || new Date();
        this._updatedAt = updatedAt || new Date();
    }
    get id() {
        return this._id;
    }
    get createdAt() {
        return this._createdAt;
    }
    get updatedAt() {
        return this._updatedAt;
    }
    get created_at() {
        return this._createdAt.toISOString();
    }
    get updated_at() {
        return this._updatedAt.toISOString();
    }
    touch() {
        this._updatedAt = new Date();
    }
    equals(other) {
        if (!other)
            return false;
        if (other.constructor !== this.constructor)
            return false;
        return this.id === other.id;
    }
}
exports.BaseEntity = BaseEntity;
class BaseDomainEvent {
    eventId;
    occurredAt;
    constructor() {
        this.eventId = 'evt_' + Math.random().toString(36).substring(2, 11) + '_' + Date.now();
        this.occurredAt = new Date();
    }
}
exports.BaseDomainEvent = BaseDomainEvent;
class BaseAggregateRoot extends BaseEntity {
    _domainEvents = [];
    get domainEvents() {
        return [...this._domainEvents];
    }
    addDomainEvent(event) {
        this._domainEvents.push(event);
    }
    clearDomainEvents() {
        this._domainEvents.length = 0;
    }
}
exports.BaseAggregateRoot = BaseAggregateRoot;
